module.exports = {
  ARTIFACT_GENERATION_TYPE: {
    SINGLE_FILE: 'single_file'
  },
  ARTIFACTS_REMOVED_ARTIFACT: 'ARTIFACTS_REMOVED_ARTIFACT',
  ARTIFACTS_SET_ARTIFACT_URL: 'ARTIFACTS_SET_ARTIFACT_URL',
  UPLOAD_ARTIFACT: 'UPLOAD_ARTIFACT',
  UPLOAD_PROGRESS: 'UPLOAD_PROGRESS',
  UPDATED_ARTIFACT: 'UPDATED_ARTIFACT',
  RECEIVE_ARTIFACTS: 'RECEIVE_ARTIFACTS',
  RECEIVE_RELEASE: 'RECEIVE_RELEASE',
  RECEIVE_RELEASES: 'RECEIVE_RELEASES',
  RELEASE_REMOVED: 'RELEASE_REMOVED',
  SHOW_REMOVE_DIALOG: 'SHOW_REMOVE_DIALOG',
  SELECTED_ARTIFACT: 'SELECTED_ARTIFACT',
  SELECTED_RELEASE: 'SELECTED_RELEASE'
};
